import { rfqMyQuotesFilterStyles } from "@insite/content-library/Widgets/RfqMyQuotes/RfqMyQuotesFilter";
import { rfqMyQuotesHeaderStyles } from "@insite/content-library/Widgets/RfqMyQuotes/RfqMyQuotesHeader";
import {rfqMyQuotesTableStyles} from "@insite/content-library/Widgets/RfqMyQuotes/RfqMyQuotesTable"
import { css } from "styled-components";


rfqMyQuotesFilterStyles.clearFiltersButton= {
    mergeCss: true,
    variant: "secondary",
    css: css`
        margin-right: 10px;
    `,
}

rfqMyQuotesFilterStyles.appliedFilterTag= {
    css:css`
            button {
                min-width: auto;
                &:hover {
                    border: none !important;
                    background: none !important;
                }
                &:focus {
                    outline: none !important;
                }
            }
        `
}

rfqMyQuotesTableStyles.wrapper= {
    css: css`
        overflow: auto;
        margin-top: 30px !important;
    `,
}

rfqMyQuotesHeaderStyles.statusFilterGridItem={
    width: [12, 6, 4, 3, 2],
        css:css`
            margin-top:15px !important;
        `,
}